module.exports = __webpack_public_path__ + "img/Group 1219.4bb6d8fa.svg";